// Safari shares one platform audio session between Web Audio, media elements,
// and speech recognition. Playback mode must never override an active capture.
export class BrowserAudioSession {
  constructor(getSession = () => globalThis.navigator?.audioSession) {
    this.getSession = getSession; this.captures = new Set();
  }
  sync() {
    try {
      const session = this.getSession(), type = this.captures.size ? 'play-and-record' : 'playback';
      if (session && session.type !== type) session.type = type;
    } catch { /* This experimental API is optional; normal browser audio still works. */ }
  }
  beginCapture() {
    const capture = {};
    this.captures.add(capture); this.sync();
    // Repeat calls also reconcile late native shutdown/permission callbacks,
    // without releasing a newer capture that may already have started.
    return () => { this.captures.delete(capture); this.sync(); };
  }
}

export const audioSession = new BrowserAudioSession();

// On iOS resume() can remain pending after an interruption. Always call it in
// the user's gesture, but bound the wait so Play can offer another attempt.
export async function resumeAudioContext(context, timeoutMs = 2000) {
  let timer;
  try {
    await Promise.race([
      context.resume(),
      new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('Audio did not respond. Tap Play to reconnect sound.')), timeoutMs); }),
    ]);
    if (context.state !== 'running') throw new Error('Audio is interrupted. Tap Play to reconnect sound.');
  } finally { clearTimeout(timer); }
}
